module.exports = __webpack_public_path__ + "static/header-background-3e6ef3f8e20e943941a7f3dee05ae98b.svg";